import { useEffect, useState } from 'react';
import _ from 'lodash';
import * as api from '../../../api';

import AppointmentPage from './AppointmentPage';
import { SelectedAppointment } from '../../../components/ScheduleAppointment/AppointmentDisplay/common';

export interface ScheduleAppointmentPageProps {
  formField: api.PrevisitFormField.PrevisitFormFieldWithConfig;
  navigateToNextPage: () => Promise<void>;
  onAppointmentSelected: (
    timeSlot: api.EhrTimeSlot.EhrTimeSlot,
    seriesAppointmentCount?: number,
  ) => Promise<{ navigateToConfirmation: boolean }>;
  practice?: api.Practice.Practice;
  encounter?: api.Encounter.Encounter;
  provisionalPatientId?: string;
}

const ScheduleAppointmentPage: React.FC<ScheduleAppointmentPageProps> = ({
  formField,
  navigateToNextPage,
  onAppointmentSelected,
  practice,
  encounter,
  provisionalPatientId,
}) => {
  const [selectedAppointment, setSelectedAppointment] = useState<
    SelectedAppointment | undefined
  >(undefined);

  useEffect(() => {
    try {
      const parsedValue = !!formField.value && JSON.parse(formField.value);
      if (parsedValue) {
        setSelectedAppointment(parsedValue.selectedAppointment);
      } else {
        setSelectedAppointment(undefined);
      }
    } catch {
      console.warn('ScheduleAppointmentPage could not parse form field value');
    }
  }, [formField.value, formField.id]);

  return (
    <AppointmentPage
      fieldConfig={{
        ..._.pick(formField, [
          'label',
          'helpDialog',
          'scheduleAppointmentDisplayBy',
          'scheduleAppointmentSortBy',
          'scheduleAppointmentStartTime',
          'scheduleAppointmentEndTime',
          'scheduleAppointmentCallSectionEnabled',
          'scheduleAppointmentCommentEnabled',
          'customConfigs',
        ]),
        previsitFormFieldId: formField.id,
      }}
      selectedAppointment={selectedAppointment}
      navigateToNextPage={navigateToNextPage}
      onAppointmentSelected={onAppointmentSelected}
      practice={practice}
      encounter={encounter}
      provisionalPatientId={provisionalPatientId}
    />
  );
};

export default ScheduleAppointmentPage;
